var Browser = Browser || {};

(function (){

    Browser.isSupported = function() {
        var userAgent = window.navigator.userAgent.toLowerCase();

        if (userAgent.indexOf('msie') == -1 && userAgent.indexOf('trident') == -1) {
            return true;
        }

        var versions = /(msie|rv:?)\s?([\d\.]+)/.exec(userAgent);
        var version = (versions) ? parseInt(versions[2], 10) : 0;

        if (version >= 9) {
            return true;
        }

        // check IE Compatibility
        if (version == 7 && userAgent.indexOf('trident') >= 0) {
            var compatibilityVersions = /trident\/([\d\.]+)/.exec(userAgent);
            var compatibilityVersion = (compatibilityVersions) ? parseInt(compatibilityVersions[1], 10) : 0;
            if (compatibilityVersion > 4) {
                return true;
            }
        }

        return false;
    }
})();
